// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"51fd7d23","955":"74eb54f0"}[chunkId] + ".chunk.js";
};